export const PRICE_FILTER_SLIDER_THRESHOLD = 15;
export const PRICE_FILTER_REGULAR_SIZE_CLASSES = 'px-3 py-1.5 text-sm';
export const PRICE_FILTER_COMPACT_SIZE_CLASSES = 'px-1 py-1 text-xs';
